import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "40",
  height: "40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 40"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M16.667 19.225a6.679 6.679 0 0 1 6.666 0m-8.619-3.939a6.667 6.667 0 1 1-9.428 9.428 6.667 6.667 0 0 1 9.428-9.428Zm20 0a6.667 6.667 0 1 1-9.428 9.428 6.667 6.667 0 0 1 9.428-9.428Z",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }